import { Col, Container, Row } from "react-bootstrap"
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import ExportBox from "../components/ExportBox/ExportBox"
import DashboardCards from "../components/DashboardCards/DashboardCards"
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import Table from "../components/Table/Table"
import Select from 'react-select';

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import WeeklyCurve from "../components/WeeklyCurve/WeeklyCurve"
import TodayCurve from "../components/TodayCurve/TodayCurve"
import axios from "axios"

function HomeDashboard() {
  const userinfo = useSelector((state) => state);

  const [item, setItem] = useState([])
  const [totalItem, setTotalItem] = useState(0)

  const [purchases, setPurchases] = useState([])
  const [totalPurchases, setTotalPurchases] = useState(0)

  const [salaries, setSalaries] = useState([])
  const [years, setYears] = useState([])
  const [year_id, setYear_id] = useState(null)
  const [day_id, setDay_id] = useState(null)
  const [type_id, setType_id] = useState(null)
  const [month_id, setMonth_id] = useState(null)
  const [totalSalaries, setTotalSalaries] = useState(0)
  const [finance, setFinance] = useState([])
  const [totalFinance, setTotalFinance] = useState(0)
  const [allTotal, setAllTotal] = useState(0)
  const [studenItem, setStudenItem] = useState(0)
  const [filterApplied, setFilterApplied] = useState('')
  const [allFinance, setAllFinance] = useState([])
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const monthes = [
    { label: currentLocal.home.january, value: 1 },
    { label: currentLocal.home.february, value: 2 },
    { label: currentLocal.home.march, value: 3 },
    { label: currentLocal.home.april, value: 4 },
    { label: currentLocal.home.may, value: 5 },
    { label: currentLocal.home.june, value: 6 },
    { label: currentLocal.home.july, value: 7 },
    { label: currentLocal.home.august, value: 8 },
    { label: currentLocal.home.september, value: 9 },
    { label: currentLocal.home.october, value: 10 },
    { label: currentLocal.home.november, value: 11 },
    { label: currentLocal.home.december, value: 12 },
  ];
  const days = Array.from({ length: 31 }, (_, i) => ({
    label: i + 1,
    value: i + 1,
  }));
  const types = [
    { value: "income", label: currentLocal.home.income },
    { value: "expenses", label: currentLocal.home.expenses },

  ]
  console.log(allFinance);
  
  const getAllApis = async () => {


    await axios
      .get(`https://nanosoft.space/taarteb/public/api/admin/maintenances`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        setItem(res.data.data);

        console.log(res.data.data, "res.data.data");

        setTotalItem(Number(res.data.data.total_cost));

      })
      .catch((error) => {
        console.log(error);


      });
    await axios
      .get(`https://nanosoft.space/taarteb/public/api/admin/purchases`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        setPurchases(res.data.data);
        setTotalPurchases(Number(res.data.data.total_cost));

      })
      .catch((error) => {
        console.log(error);


      });

    await axios
      .get(`https://nanosoft.space/taarteb/public/api/admin/salaries`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        setSalaries(res.data.data);



        setTotalSalaries(res.data.data.total_cost);

      })
      .catch((error) => {
        console.log(error);


      });
    await axios
      .get(`https://nanosoft.space/taarteb/public/api/admin/student-expenses`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        console.log(res.data.data, "ldsa;d");

        setFinance(res.data.data?.student_expenses);

        const total = res.data.data.student_expenses.reduce((sum, item) => sum + (item?.status === "pending" ? 0 : item.amount_paid || 0), 0);

        setTotalFinance(total);
      })
      .catch((error) => {
        console.log(error);


      });



    // await axios
    //     .get(`https://taarteb.com/api/todays-attendance-statistics`, {
    //         headers: {
    //             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
    //         }
    //     })
    //     .then(async (res) => {
    //         setTodayItems(res.data.data)
    //     })
    //     .catch((error) => {





    //     });
    // await axios
    //     .get(`https://taarteb.com/api/weekly-attendance-report`, {
    //         headers: {
    //             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
    //         }
    //     })
    //     .then(async (res) => {
    //         setWeeklyItems(res.data.data)


    //     })
    //     .catch((error) => {





    //     });

  }
  const getpurchasesData = async () => {



    await axios
      .get(`https://nanosoft.space/taarteb/public/api/my-purchases`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {

        setPurchases(res.data.data);
        const total = res.data.data.reduce((sum, item) => {
          // ensure price is a number
          return sum + (parseFloat(item.price) || 0);
        }, 0);

        setTotalPurchases(total);

      })
      .catch((error) => {
        console.log(error);


      });
  }
  const getmaintenanceData = async () => {



    await axios
      .get(`https://nanosoft.space/taarteb/public/api/my-maintenances`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        setItem(res.data.data);
        const total = res.data.data.reduce((sum, item) => {
          // ensure price is a number
          return sum + (parseFloat(item.price) || 0);
        }, 0);
        setTotalItem(total);

      })
      .catch((error) => {
        console.log(error);


      });
  }
  const getsalariesData = async () => {



    await axios
      .get(`https://nanosoft.space/taarteb/public/api/salaries`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        setSalaries(res.data.data.data);
        const total = res.data.data.data.reduce((sum, item) => {
          // ensure price is a number
          return sum + (parseFloat(item.total) || 0);
        }, 0);

        setTotalSalaries(total);

      })
      .catch((error) => {
        console.log(error);


      });
  }
  const getsalesData = async () => {



    await axios
      .get(`https://nanosoft.space/taarteb/public/api/admin/student-expenses`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {
        setFinance(res.data.data);
        const accepted = res.data.data.filter((item) => item?.status == "accepted")

        const total = accepted.reduce((sum, item) => sum + (item.amount_paid || 0), 0);
        setTotalFinance(total);
      })
      .catch((error) => {
        console.log(error);


      });
  }
  const getstudentsData = async () => {


    const response = await axios.get(
      `https://nanosoft.space/taarteb/public/api/student/required-expenses`,

      {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        },
      }
    );

    //         const updatedData = response.data.data.map(item => ({
    //   ...item,
    //   status: item.status == null ? "pinding": item.status,
    //   pay_date:item.pay_date==null?"_________":item.pay_date
    // }));
    console.log(response.data.data);

    setStudenItem(response.data.data)

  }
  const getAllFinanceData = async () => {

    let years = []; // your array for years

    // get current year
    const currentYear = new Date().getFullYear();

    // only add if not found
    if (!years.includes(currentYear)) {
      years.push(currentYear);
    }

    const formattedYears = years?.map((year) => ({
      label: year,
      value: year,
    }));
    setYears(formattedYears)

    let filter_type = "year";
    if (year_id?.value != null && day_id?.value != null) {
      filter_type = "day";
    } else if (month_id?.value != null) {
      filter_type = "month";
    }
    const params = new URLSearchParams();
    params.append("year", year_id?.value);
    params.append("filter_type", filter_type);

    if (month_id?.value != null) {
      params.append("month", month_id?.value);
    }
    if (day_id?.value != null) {
      params.append("day", day_id?.value);
    }


    await axios
      .get(year_id || month_id || day_id ? `https://nanosoft.space/taarteb/public/api/financial-report?${params.toString()}` : `https://nanosoft.space/taarteb/public/api/financial-report`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      })
      .then(async (res) => {

        setAllTotal(Number(res.data.data?.income?.total) + res.data.data?.expenses?.total)
        setFilterApplied(res.data.data.filter_applied)
        const merged = [
          ...Object.entries(res.data.data.income)?.map(([key, value]) => ({
            type: "income",
            key,
            value: Number(value),
          })),
          ...Object.entries(res.data.data.expenses)?.map(([key, value]) => ({
            type: "expense",
            key,
            value: Number(value),
          })),
        ];

        const cleaned = merged.filter(
          (item) => !(item.type === "income" && item.key === "total")
        );
        const totalData = cleaned.filter(
          (item) => !(item.type === "expense" && item.key === "total")
        );
        const localized = totalData?.map(item => ({
          ...item,
          type: item.type == "income"
            ? currentLocal.home.income
            : item.type == "expense"
              ? currentLocal.home.expenses
              : item.type
        }));

        const permissionslocalized = localized?.map(item => ({
          ...item,
          key: item.key === "salaries"
            ? currentLocal.home.Salaries
            : item.key === "maintenance"
              ? currentLocal.home.Maintenance
              : item.key === "purchases"
                ? currentLocal.home.Purchases
                : item.key === "student_payments"
                  ? currentLocal.home.Studyexpenses
                  : item.key
        }));
        setAllFinance(permissionslocalized);

        if (type_id) {
          const allDataAfterFilter = permissionslocalized.filter((item) => item?.type == type_id?.label)
          setAllFinance(allDataAfterFilter);


        }

        // const total = res.data.data.reduce((sum, item) => {
        //     // ensure price is a number
        //     return sum + (parseFloat(item.salary) || 0);
        // }, 0);

        // setTotalSalaries(total);

      })
      .catch((error) => {
        console.log(error);


      });
  }


  useEffect(() => {
    getAllFinanceData()
    if (localStorage.getItem("type") === "admin" || localStorage.getItem("type") === "financial") {
      getAllApis()

    } else if (localStorage.getItem("type") === "purchases") {
      getpurchasesData()
    } else if (localStorage.getItem("type") === "maintenance") {
      getmaintenanceData()

    } else if (localStorage.getItem("type") === "salaries") {
      getsalariesData()

    } else if (localStorage.getItem("type") === "student") {
      getstudentsData()
    } else if (localStorage.getItem("type") === "sales") {
      getsalesData()

    }
    //   else if(localStorage.getItem("type")==="student"){
    //        getstudentsData()

    //   }

  }, [currentLocal, year_id, month_id, day_id, type_id])
  const headerIterm = [
    // currentLocal.home.namePlaceholder,
    currentLocal.home.permissions,
    currentLocal.home.price,
    currentLocal.home.type,
    // currentLocal.home.date,


  ]

  const items = localStorage.getItem("type") === "admin" ? [
    // { name:currentLocal.home.Administrators,num: item && item.students,path:"/dashboard/Students"  },
    { name: currentLocal.home.Sales, num: finance && finance.length, path: "/dashboard/finance" },
    { name: currentLocal.home.Purchases, num: purchases && purchases?.data?.length, path: "/dashboard/Purchases" },
    { name: currentLocal.home.Salaries, num: salaries && salaries?.data?.data?.length, path: "/dashboard/salaries" },

    { name: currentLocal.home.Maintenance, num: item && item?.data?.length, path: "/dashboard/maintenance" },

  ] : localStorage.getItem("type") === "purchases" ? [
    { name: currentLocal.home.Purchases, num: purchases && purchases?.length, path: "/dashboard/Purchases" },

  ] : localStorage.getItem("type") === "maintenance" ? [

    { name: currentLocal.home.Maintenance, num: item && item.length, path: "/dashboard/maintenance" },

  ] : localStorage.getItem("type") === "salaries" ? [
    { name: currentLocal.home.Salaries, num: salaries && salaries.length, path: "/dashboard/salaries" },

  ] : localStorage.getItem("type") === "financial" ? [
    { name: currentLocal.home.Sales, num: finance && finance.length, path: "/dashboard/finance" },
    { name: currentLocal.home.Purchases, num: purchases && purchases.length, path: "/dashboard/Purchases" },
    { name: currentLocal.home.Salaries, num: salaries && salaries.length, path: "/dashboard/salaries" },

    { name: currentLocal.home.Maintenance, num: item && item.length, path: "/dashboard/maintenance" },

  ] : localStorage.getItem("type") === "student" ?
    [
      { name: currentLocal.home.Studyexpenses, num: "", path: "/dashboard/student/Finance" },
      // { name: currentLocal.home.Studyexpenses, num: studenItem[0]?.total_amount_paid+studenItem[0]?.registration_fee_deduction+" "+currentLocal.home.currancy, path: "/dashboard/student/Finance" },
      // { name: currentLocal.home.forms, num: purchases && purchases.length, path: "/dashboard/student/Finance" },


    ] : localStorage.getItem("type") === "sales" &&
    [
      { name: currentLocal.home.Sales, num: finance && finance.length, path: "/dashboard/finance" },

    ]



  const printTable = () => {
    const content = document.getElementById("financialTable").innerHTML;

    const printWindow = window.open("", "_blank", "width=900,height=700");
    printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>${currentLocal.home.FinanceReport}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body {
            font-family: Arial, sans-serif;
            direction: rtl;
            padding: 20px;
          }
          .fw-bold {
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          table, th, td {
            border: 1px solid #000;
          }
          th, td {
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f8f8f8;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };
  const allFinanceData = () => {
    const type = localStorage.getItem("type");

    const getStatusText = (status) => {
      switch (status) {
        case "accepted":
          return currentLocal.home.accept;
        case "pending":
          return currentLocal.home.pending;
        case "rejected":
          return currentLocal.home.reject;
        default:
          return status;
      }
    };

    return (
      <tbody>
        {allFinance?.map((item) => {

          return (
            <tr key={item.id}>
              <td>{item?.key}</td>


              <td>
                {item?.value} {currentLocal.home.currancy}
              </td>
              <td>{item?.type}</td>





            </tr>
          )
        })}
      </tbody>
    );
  };
  console.log(type_id?.value);


  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <ToastContainer />

      <Container>
        <div className="d-flex flex-column w-100">
          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.ManageYourSchoolsEfficiently} />


            <ExportBox title={currentLocal.home.QuickSummary}
              paragrapg={currentLocal.home.Summary}
              exportState={false}
              btnState={false}

            />
            {localStorage.getItem("type") === "student" ?
              <p className="w-100 text-start fw-bold"> {currentLocal.home.Total}:{studenItem?.[0]?.total_amount_paid}{" "}{currentLocal.home.currancy}</p>

              :
              <>
                <p className="w-100 text-start fw-bold"> {currentLocal.home.Total}{" "}{currentLocal.home.expenses}:{allFinance?.[1]?.value + allFinance?.[2]?.value + allFinance?.[3]?.value}{" "}{currentLocal.home.currancy}</p>
                <p className="w-100 text-start fw-bold"> {currentLocal.home.Total}{" "}{currentLocal.home.income}:{allFinance?.[0]?.value}{" "}{currentLocal.home.currancy}</p>
              </>
            }
            {/* <DashboardCards
              items={items}
            /> */}
            {(localStorage.getItem("type") === "admin" || localStorage.getItem("type") === "financial") &&

              <>
                <Row className="mb-4">
                  <h4 className="mb-3">{currentLocal.home.Finance}</h4>



                  <Col md={3} className="mb-3">
                    <Select
                      value={type_id}
                      onChange={(selectedOption) => setType_id(selectedOption)}
                      options={types}
                      placeholder={currentLocal.home.type} // Change this text

                    />
                  </Col>
                  <Col md={3} className="mb-3">
                    <Select
                      value={day_id}
                      onChange={(selectedOption) => {
                        if (month_id && year_id) {
                          setDay_id(selectedOption)
                        } else {
                          toast.error(
                            !year_id ? currentLocal.home.chooseYearFirst : currentLocal.home.chooseMonthFirst,
                            { position: "bottom-right", autoClose: 3000 }
                          );

                        }
                      }}
                      //     onChange={(selectedOption) => {
                      //                    if(month_id&&year_id){
                      //         setDay_id(selectedOption)}
                      //         }else{
                      //                             toast.error(
                      //                                currentLocal.home.chooseYearFirst,
                      //                                 { position: "bottom-right", autoClose: 3000 }
                      //                             );


                      //     }
                      // }

                      options={days}
                      placeholder={currentLocal.home.SelectDays} // Change this text

                    />
                  </Col>

                  <Col md={3} className="mb-3">
                    <Select
                      value={month_id}
                      onChange={(selectedOption) => {
                        if (year_id) {
                          setMonth_id(selectedOption)
                        } else {
                          toast.error(
                            currentLocal.home.chooseYearFirst,
                            { position: "bottom-right", autoClose: 3000 }
                          );

                        }
                      }}
                      options={monthes}
                      placeholder={currentLocal.home.SelectMonth} // Change this text

                    />
                  </Col>
                  <Col md={3} className="mb-3">
                    <Select
                      value={year_id}
                      onChange={(selectedOption) => setYear_id(selectedOption)}
                      options={years}
                      placeholder={currentLocal.home.Selectyear} // Change this text

                    />
                  </Col>

                </Row>
                <button onClick={printTable} className="btn  border mb-3 mt-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                  </svg>
                </button>
                <div id="financialTable">
                  <Row>
                    <Col md={4} className="mb-3" >
                      <div>
                        {type_id?.value == "expenses" ?
                          <p className="w-100 "> <span className="fw-bold">{currentLocal.home.Total}{" "}{currentLocal.home.expenses}</span>:{allFinance?.[0]?.value + allFinance?.[1]?.value + allFinance?.[2]?.value}{" "}{currentLocal.home.currancy}</p>

                          : type_id?.value == "income" ?
                            <p className="w-100 "><span className="fw-bold"> {currentLocal.home.Total}{" "}{currentLocal.home.income}</span>:{allFinance?.[0]?.value}{" "}{currentLocal.home.currancy}</p>

                            :
                            <>
                              <p className="w-100 "> <span className="fw-bold">{currentLocal.home.Total}{" "}{currentLocal.home.expenses}</span>:{allFinance?.[1]?.value + allFinance?.[2]?.value + allFinance?.[3]?.value}{" "}{currentLocal.home.currancy}</p>
                              <p className="w-100 "><span className="fw-bold"> {currentLocal.home.Total}{" "}{currentLocal.home.income}</span>:{allFinance?.[0]?.value}{" "}{currentLocal.home.currancy}</p>

                            </>
                        }
                        <p> <span className="fw-bold">{currentLocal.home.FilterBy} :</span> {filterApplied}</p>

                      </div>

                    </Col>
                  </Row>
                  <Row>
                    <Table
                      body={allFinanceData()}
                      headerIterm={headerIterm}
                      actions={["view"]}

                    />
                  </Row>
                </div>
              </>
            }

          </div>


        </div>
      </Container>
    </div>
  )
}

export default HomeDashboard